module.exports = __webpack_public_path__ + "img/menu3.961fb727.svg";